import {
  Button,
  ListRow,
  SettingsList,
  SettingsRow,
  UsageMeter,
} from '@relay-towing/ui';
import { usageMeters } from '@relay-towing/api';
import { usePlan, usePlanUsage } from '../../hooks/usePlan';
import { links } from '../../lib/links';
import { openExternal } from '../../lib/nativeBridge';

/**
 * The company's plan and how much of it is used. A member who manages the
 * subscription gets Upgrade, which opens the dashboard's billing in the
 * system browser; everyone else is told who to ask.
 */
export function PlanSection() {
  const plan = usePlan();
  const usage = usePlanUsage();
  const catalogue = plan.catalogue;

  const meters =
    catalogue && usage.data ? usageMeters(catalogue, usage.data) : [];

  return (
    <SettingsList
      title="Plan"
      footnote={
        plan.canUpgrade ? undefined : 'Ask your owner to upgrade the plan.'
      }
    >
      <SettingsRow
        label="Current plan"
        value={plan.name ?? (plan.isLoading ? '…' : 'Unknown')}
        control={
          plan.canUpgrade ? (
            <Button size="sm" onClick={() => openExternal(links.billing)}>
              Upgrade
            </Button>
          ) : undefined
        }
      />
      {meters.map(({ limit, name, used, allowed, near }) => (
        <ListRow key={limit} inset="md">
          <UsageMeter
            className="grow"
            label={name}
            used={used}
            limit={allowed}
            near={near}
          />
        </ListRow>
      ))}
      {usage.isError ? (
        <SettingsRow label="Usage" value="Did not load" />
      ) : null}
    </SettingsList>
  );
}
